import { render, staticRenderFns } from "./AccessPermissions.vue?vue&type=template&id=3b20c958&"
import script from "./AccessPermissions.vue?vue&type=script&lang=ts&"
export * from "./AccessPermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b20c958')) {
      api.createRecord('3b20c958', component.options)
    } else {
      api.reload('3b20c958', component.options)
    }
    module.hot.accept("./AccessPermissions.vue?vue&type=template&id=3b20c958&", function () {
      api.rerender('3b20c958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/access-permissions/views/AccessPermissions.vue"
export default component.exports